import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Edit } from '../../images/icons/modifica.svg';

interface IProps extends StyledComponentProps {
    onClick: (evt) => any;
    disabled?: boolean;
}

const EditButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.iconButtonRootSvgBlack}
        onClick={props.onClick}>
            <Edit className={props.classes.iconButtonSvgBlack}/>
    </MuiButton>)
}


export default withStyles(styles)(EditButton)